import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'aside';
const idGen = new IDGenerator('wm_left_panel');

register('wm-left-panel', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmLeftPanel #${counter}="wmLeftPanel" pageContainer data-role="page-left-panel" role="navigation" class="app-left-panel" [attr.aria-label]="${counter}.hint || 'Left navigation panel'" ${getAttrMarkup(attrs)}><div class="app-ng-transclude" wmsTransclude page-container-target>`;

        },
        post: () => `</div></${tagName}>`
    };
});

export default () => {};
